import * as React from "react";
import _ from "lodash";

import useLocalStorage from "src/library/hooks/useLocalStorage";
import {
  IPromotion,
  usePromotionsApi,
  PromotionTemplate,
  PromotionsRequestName
} from "src/modules/promotions/api/promotions.api";

interface DropPromotionsContext {
  promotions: IPromotion[];
}

const DropPromotionsContext = React.createContext<DropPromotionsContext>({ promotions: [] });

interface DropPromotionsProviderProps {
  dropId: number;
}

export const useDropPromotions = () => React.useContext(DropPromotionsContext);

export const DropPromotionsProvider: React.ReactFCWithChildren<DropPromotionsProviderProps> = ({ dropId, children }) => {
  const [ listPromotionsRes, listPromotionsReq ] = usePromotionsApi(PromotionsRequestName.LIST_PROMOTIONS_BY_DROP);

  React.useEffect(() => {
    if (dropId) {
      listPromotionsReq({ dropId });
    }
  }, [ dropId, listPromotionsReq ]);

  const promotions = React.useMemo(() => {
    if (listPromotionsRes.data) {
      // cleanse out invalid template types
      return _.filter(listPromotionsRes.data, item => Object.values(PromotionTemplate).includes(item.template));
    }

    return [];
  }, [ listPromotionsRes.data ]);

  return (
    <DropPromotionsContext.Provider
      value={{ promotions }}
    >
      {children}
    </DropPromotionsContext.Provider>
  );
};
